import Reveal from '@/components/base/Reveal';

const pillars = [
  { number: '01', title: 'On the Air',  body: 'Live and recorded shows hosted and produced by young people.' },
  { number: '02', title: 'In the Code', body: 'Open-source software shipped by student engineers and mentors.' },
  { number: '03', title: 'In the World', body: 'Stories, journalism, and projects that connect to real communities.' },
];

export default function VisionSection() {
  return (
    <section id="vision" className="relative py-28 px-6 md:px-12 lg:px-16 bg-[#080808]">
      <div className="max-w-7xl mx-auto">
        <div className="lg:grid lg:grid-cols-2 lg:gap-24 lg:items-center">
          {/* Left */}
          <div className="mb-16 lg:mb-0">
            <Reveal variant="fadeRight" duration={800}>
              <p className="text-xs tracking-[0.3em] text-white/60 uppercase mb-4">Our Mission</p>
            </Reveal>
            <Reveal variant="fadeRight" delay={100} duration={900}>
              <h2
                className="text-4xl md:text-5xl lg:text-6xl font-normal font-['Instrument_Serif'] text-white"
                style={{ letterSpacing: '-0.02em' }}
              >
                Giving youth a voice<br />in the real world.
              </h2>
            </Reveal>

            <Reveal variant="scaleUp" delay={300} duration={900} threshold={0.1}>
              <div className="mt-10">
                <img
                  src="/studio.jpg"
                  alt="Radio Studio"
                  className="w-full h-[260px] object-cover object-top rounded-xl opacity-60"
                />
              </div>
            </Reveal>
          </div>

          {/* Right - Pillars */}
          <div className="space-y-0 divide-y divide-white/5">
            {pillars.map((pillar, i) => (
              <Reveal key={pillar.number} variant="fadeLeft" delay={i * 160} duration={800} threshold={0.1}>
                <div className="py-10 group cursor-default">
                  <div className="flex items-start gap-6">
                    <span className="text-xs text-white/45 font-mono mt-1 shrink-0">{pillar.number}</span>
                    <div>
                      <h3 className="text-2xl font-medium text-white font-['Instrument_Serif'] mb-2" style={{ letterSpacing: '-0.02em' }}>{pillar.title}</h3>
                      <p className="text-sm text-white/60">{pillar.body}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
